export default __webpack_public_path__ + "static/tekrevol_dubai_ae_loc-ed7aa08ab1f0814ea8d2b93a83e71ca2.webp";